module.exports = __webpack_public_path__ + "static/bg-light-desc-603aca709ab771bc3f9138700411909a.webp";